import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Applicationdefs } from '../../../../../core/entities/applicationdefs.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsApplicationdefsComponent } from './dialogs-applicationdefs/edit-dialogs-applicationdefs/edit-dialogs-applicationdefs.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationdefsService } from '../../../../../core/repositories/applicationdefs.service';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/core/utils/utils';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';

@Component({
  selector: 'app-aplicationdefs',
  templateUrl: './aplicationdefs.component.html',
  styleUrls: ['./aplicationdefs.component.scss']
})
export class AplicationdefsComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  applicationdef: Applicationdefs = new Applicationdefs();
  aplicationdefRemove:  Applicationdefs = new Applicationdefs();

  mensajeError: boolean = false;

  constructor(public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private applicationdefsService: ApplicationdefsService) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllApplicationdefs();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla applicationdefs
  */
  private getAllApplicationdefs(): void {
    this.loading = true;
    this.internalHomeService.allApplicationdefs().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un applicationdef
  * @param dbattr Opcional. Applicationdef vacio.
  */
  public createApplicationdef(applicationdef?: Applicationdefs) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = this.translateService.instant('CREACION.applicationdefs');
    let disabledApplicationdef = false;
    applicationdef = this.applicationdef;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsApplicationdefsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { applicationdef, titulochange, disabledApplicationdef }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: Applicationdefs) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result != null)
      setTimeout(() => {
        this.getAllApplicationdefs();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un applicationdef
  * @param dbattr Opcional. Applicationdef a editar.
  */
  public editApplicationdef(applicationdef?: Applicationdefs) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = this.translateService.instant('EDICION.applicationdefs');
    let disabledApplicationdef = false;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsApplicationdefsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { applicationdef, titulochange, disabledApplicationdef}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: Applicationdefs) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result != null)
      setTimeout(() => {
        this.getAllApplicationdefs();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un applicationdef
  * @param applicationdef Applicationdef a eliminar
  */
  public removeApplicationdef(applicationdef?: Applicationdefs) {
    Utils.toggleAllButtonsAndHref(null);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_applicationdefs') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(null);
      if (result) {
        this.loading = true;
        if (applicationdef) {
          this.aplicationdefRemove = applicationdef;
          this.aplicationdefRemove.typefinders = [];
        }
        this.applicationdefsService.postApplicationdef(this.aplicationdefRemove);
        this.internalHomeService.removeApplicationdefs(this.aplicationdefRemove).subscribe(res => {
          console.log(res);
          this.getAllApplicationdefs();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
